<div class="firma-page" *ngIf="!loading && order; else loadingOrError">
  <div class="firma-page__header">
    <button type="button" class="firma-page__back" (click)="goBack()">
      <i class="bi bi-arrow-left" aria-hidden="true"></i>
      Atrás
    </button>
    <h1 class="firma-page__title">
      <span class="firma-page__title-main">Firma digital -</span>
      <span class="firma-page__title-guide">Guía Nº {{ folioLabel }}</span>
    </h1>
  </div>

  <div class="firma-page__columns">
    <!-- Izquierda -->
    <section
      class="firma-panel"
      [class.firma-panel--tab-first]="leftTab === 'datos'"
      [class.firma-panel--tab-last]="leftTab === 'advertencias'">
      <div class="firma-tabs">
        <button
          type="button"
          class="firma-tab"
          [class.firma-tab--active]="leftTab === 'datos'"
          (click)="setLeftTab('datos')">
          Datos
        </button>
        <button
          type="button"
          class="firma-tab"
          [class.firma-tab--active]="leftTab === 'guia'"
          (click)="setLeftTab('guia')">
          Guía
        </button>
        <button
          type="button"
          class="firma-tab firma-tab--wide"
          [class.firma-tab--active]="leftTab === 'advertencias'"
          (click)="setLeftTab('advertencias')">
          Advertencias
        </button>
      </div>

      <div class="firma-panel__body" *ngIf="leftTab === 'datos'">
        <div class="datos-block datos-block--border-b">
          <div class="datos-row">
            <span class="datos-label">cliente</span>
            <span class="datos-value">{{ displayOrDash(order.clientName) }}</span>
          </div>
          <div class="datos-row">
            <span class="datos-label">rut cliente</span>
            <span class="datos-value">{{ displayOrDash(order.clientCode) }}</span>
          </div>
          <div class="datos-row">
            <span class="datos-label">obra</span>
            <span class="datos-value">{{ displayOrDash(order.workName) }}</span>
          </div>
          <div class="datos-row">
            <span class="datos-label">dirección entrega</span>
            <span class="datos-value">{{ displayOrDash(order.deliveryAddress) }}</span>
          </div>
        </div>

        <div class="datos-row datos-row--product">
          <span class="datos-label">PRODUCTO</span>
          <span class="datos-value">
            {{ displayOrDash(order.actualQuantityShipped) }}{{ order.um }}
            {{ displayOrDash(order.productDescription) }}
          </span>
        </div>

        <div class="datos-block datos-block--border-t">
          <div class="datos-row">
            <span class="datos-label">despachos</span>
            <span class="datos-value">
              {{ ticketOrdinal(order.currentTripNumber) }} ticket de {{ order.loadAmount }}
            </span>
          </div>
          <div class="datos-row">
            <span class="datos-label">hora deseada</span>
            <span class="datos-value">{{ displayOrDash(order.startTime) }}</span>
          </div>
          <div class="datos-row">
            <span class="datos-label">hora llegada</span>
            <span class="datos-value">{{ displayOrDash(order.hourTwo || order.hourThree) }}</span>
          </div>
        </div>

        <div class="datos-block datos-block--border-t">
          <div class="datos-row">
            <span class="datos-label">Firma</span>
            <span class="datos-value">{{ siNo(draft.isSignature) }}</span>
          </div>
          <div class="datos-row">
            <span class="datos-label">ADICIÓN DE AGUA</span>
            <span class="datos-value">{{ siNo(draft.waterAddition) }}</span>
          </div>
          <div class="datos-row">
            <span class="datos-label">ADICIÓN OTRO INSUMO</span>
            <span class="datos-value">{{ siNo(draft.anotherAddition) }}</span>
          </div>
          <div class="datos-row">
            <span class="datos-label">DEVOLUCIÓN</span>
            <span class="datos-value">
              {{ draft.m3Returned != null ? draft.m3Returned + ' M³' : '—' }}
            </span>
          </div>
          <div class="datos-row datos-row--top">
            <span class="datos-label">Observación</span>
            <span class="datos-value">{{ displayOrDash(draft.guidingRemarks) }}</span>
          </div>
        </div>
      </div>

      <div class="firma-panel__body firma-panel__body--guia" *ngIf="leftTab === 'guia'">
        <div class="guide-preview" *ngIf="guidePdfSrc && !guideError; else guidePlaceholder">
          <app-pdf-canvas-viewer [src]="guidePdfSrc" [zoom]="1"></app-pdf-canvas-viewer>
        </div>
        <ng-template #guidePlaceholder>
          <div class="guide-placeholder" [class.guide-placeholder--error]="guideError && !guideLoading">
            <span *ngIf="guideLoading">Cargando guía…</span>
            <span *ngIf="!guideLoading">
              {{ guideError ? 'No se pudo cargar la guía' : 'Vista previa no disponible' }}
            </span>
          </div>
        </ng-template>
      </div>

      <div class="firma-panel__body" *ngIf="leftTab === 'advertencias'">
        <article class="advertencia" *ngFor="let item of advertencias">
          <h3 class="advertencia__title">{{ item.title }}</h3>
          <p class="advertencia__text">{{ item.text }}</p>
        </article>
      </div>
    </section>

    <!-- Derecha -->
    <section
      class="firma-panel"
      [class.firma-panel--no-tabs]="hideRightTabs"
      [class.firma-panel--tab-first]="!hideRightTabs && rightTab === 'observacion'"
      [class.firma-panel--tab-last]="!hideRightTabs && rightTab === 'finalizar'">
      <div class="firma-tabs firma-tabs--right" *ngIf="!hideRightTabs">
        <button
          type="button"
          class="firma-tab"
          [class.firma-tab--active]="rightTab === 'observacion'"
          (click)="setRightTab('observacion')">
          Observación
        </button>
        <button
          type="button"
          class="firma-tab"
          [class.firma-tab--active]="rightTab === 'agua'"
          (click)="setRightTab('agua')">
          Agua
        </button>
        <button
          type="button"
          class="firma-tab"
          [class.firma-tab--active]="rightTab === 'devolucion'"
          (click)="setRightTab('devolucion')">
          Devolución
        </button>
        <button
          type="button"
          class="firma-tab"
          [class.firma-tab--active]="rightTab === 'firma'"
          (click)="setRightTab('firma')">
          Firma
        </button>
        <button
          type="button"
          class="firma-tab"
          [class.firma-tab--active]="rightTab === 'finalizar'"
          (click)="setRightTab('finalizar')">
          Finalizar
        </button>
      </div>

      <!-- Despacho finalizado -->
      <div
        class="firma-panel__body firma-panel__body--workspace firma-panel__body--client firma-panel__body--exito firma-panel__body--finalizado"
        *ngIf="despachoFinalizado">
        <div class="firma-exito-panel">
          <div class="firma-exito-panel__content">
            <img
              class="firma-exito-panel__icon"
              src="assets/images/icons/despacho_finalizado.svg"
              width="119"
              height="119"
              alt="" />
            <h2 class="firma-exito-panel__title">¡Despacho finalizado!</h2>
            <p class="firma-exito-panel__text">Guía Nº {{ folioLabel }}</p>
            <p class="workspace-hint firma-exito-panel__hint" *ngIf="guiaNoFirmada">
              El despacho se finalizó con guía no firmada.
            </p>
          </div>
          <button type="button" class="btn-outline-firma firma-exito-panel__btn" (click)="continueAfterFinalize()">
            Continuar
          </button>
        </div>
      </div>
      <div
        class="firma-panel__body firma-panel__body--workspace firma-panel__body--client firma-panel__body--exito"
        *ngIf="isPaperMode && papelGuardado && !despachoFinalizado">
        <div class="firma-exito-panel">
          <div class="firma-exito-panel__content">
            <img
              class="firma-exito-panel__icon"
              src="assets/images/icons/fotografia_cargada.svg"
              width="117"
              height="117"
              alt="" />
            <h2 class="firma-exito-panel__title">Fotografía cargada</h2>
            <p class="firma-exito-panel__text">
              La imagen asociada a la Guía Nº {{ folioLabel }}
              <br />
              ha sido cargada correctamente
            </p>
            <p class="workspace-hint firma-exito-panel__hint" *ngIf="saveHint">{{ saveHint }}</p>
          </div>
          <button type="button" class="btn-outline-firma firma-exito-panel__btn" (click)="continueAfterFinalize()">
            Continuar
          </button>
        </div>
      </div>
      <div
        class="firma-panel__body firma-panel__body--workspace firma-panel__body--client"
        *ngIf="isPaperMode && !papelGuardado && !despachoFinalizado">
        <div class="papel-panel">
          <app-hormigon-paper-guide-camera
            [(photoBase64)]="papelPhotoBase64">
          </app-hormigon-paper-guide-camera>
          <div class="workspace-actions">
            <button
              type="button"
              class="btn-primary-firma"
              [disabled]="!papelPhotoBase64 || saving"
              [class.btn-primary-firma--disabled]="!papelPhotoBase64 || saving"
              (click)="savePapel()">
              {{ saving ? 'Guardando…' : 'Guardar' }}
            </button>
          </div>
          <p class="workspace-hint" *ngIf="saveHint">{{ saveHint }}</p>
          <p class="firma-page__error" *ngIf="saveError">{{ saveError }}</p>
        </div>
      </div>

      <div class="firma-panel__body firma-panel__body--workspace" *ngIf="rightTab === 'observacion' && !hideRightTabs">
        <ng-container *ngTemplateOutlet="siguientePasoBtn"></ng-container>
        <div class="workspace-row">
          <label class="workspace-label" for="firmaObs">comentarios</label>
          <textarea
            id="firmaObs"
            class="workspace-textarea"
            rows="5"
            placeholder="Ingresa tu observación"
            [(ngModel)]="obsText"></textarea>
        </div>
        <div class="workspace-actions">
          <button
            type="button"
            class="btn-primary-firma"
            [disabled]="saving || observacionSinCambios"
            [class.btn-primary-firma--disabled]="saving || observacionSinCambios"
            (click)="saveObservacion()">
            {{ saving ? 'Guardando…' : 'Guardar' }}
          </button>
        </div>
        <p class="workspace-hint" *ngIf="saveHint">{{ saveHint }}</p>
        <p class="firma-page__error" *ngIf="saveError">{{ saveError }}</p>
      </div>

      <div class="firma-panel__body firma-panel__body--workspace" *ngIf="rightTab === 'agua' && !hideRightTabs">
        <ng-container *ngTemplateOutlet="siguientePasoBtn"></ng-container>
        <div class="toggle-row">
          <span class="workspace-label">ADICIÓN DE AGUA</span>
          <div class="si-no-toggle" role="group" aria-label="Adición de agua">
            <button
              type="button"
              class="si-no-toggle__btn"
              [class.si-no-toggle__btn--on]="draft.waterAddition"
              [disabled]="aguaFirmaOpening || draft.aguaSigned"
              (click)="setWaterAddition(true)">
              SI
            </button>
            <button
              type="button"
              class="si-no-toggle__btn"
              [class.si-no-toggle__btn--on]="!draft.waterAddition"
              [class.si-no-toggle__btn--locked]="draft.aguaSigned"
              [disabled]="aguaFirmaOpening || draft.aguaSigned"
              (click)="setWaterAddition(false)">
              NO
            </button>
          </div>
        </div>
        <div class="toggle-row">
          <span class="workspace-label">otro ADITIVO</span>
          <div class="si-no-toggle" role="group" aria-label="Otro aditivo">
            <button
              type="button"
              class="si-no-toggle__btn"
              [class.si-no-toggle__btn--on]="draft.anotherAddition"
              (click)="setAnotherAddition(true)">
              SI
            </button>
            <button
              type="button"
              class="si-no-toggle__btn"
              [class.si-no-toggle__btn--on]="!draft.anotherAddition"
              (click)="setAnotherAddition(false)">
              NO
            </button>
          </div>
        </div>
        <div class="firmante-info" *ngIf="draft.aguaSigned && aguaFirmante as firmante">
          <h3 class="firmante-info__title">Firmado por</h3>
          <div class="firmante-info__row">
            <span class="firmante-info__label">Nombre</span>
            <span class="firmante-info__value">{{ firmante.nombre }}</span>
          </div>
          <div class="firmante-info__row">
            <span class="firmante-info__label">RUT</span>
            <span class="firmante-info__value">{{ firmante.rut }}</span>
          </div>
          <div class="firmante-info__row">
            <span class="firmante-info__label">Observación</span>
            <span class="firmante-info__value">{{ firmante.comentario }}</span>
          </div>
        </div>
        <p class="firma-page__error" *ngIf="saveError">{{ saveError }}</p>
        <div class="workspace-actions" *ngIf="draft.aguaSigned">
          <button
            type="button"
            class="btn-primary-firma btn-primary-firma--disabled"
            disabled>
            Firmado
          </button>
        </div>
      </div>

      <div class="firma-panel__body firma-panel__body--workspace" *ngIf="rightTab === 'devolucion' && !hideRightTabs">
        <ng-container *ngTemplateOutlet="siguientePasoBtn"></ng-container>
        <div class="toggle-row">
          <span class="workspace-label">DEVOLUCIÓN</span>
          <div class="si-no-toggle" role="group" aria-label="Devolución">
            <button
              type="button"
              class="si-no-toggle__btn"
              [class.si-no-toggle__btn--on]="devolucionSi"
              [disabled]="devolucionFirmaOpening || draft.devolucionSigned"
              (click)="setDevolucion(true)">
              SI
            </button>
            <button
              type="button"
              class="si-no-toggle__btn"
              [class.si-no-toggle__btn--on]="!devolucionSi"
              [class.si-no-toggle__btn--locked]="draft.devolucionSigned"
              [disabled]="devolucionFirmaOpening || draft.devolucionSigned"
              (click)="setDevolucion(false)">
              NO
            </button>
          </div>
        </div>
        <div class="firmante-info" *ngIf="draft.devolucionSigned && devolucionFirmante as firmante">
          <h3 class="firmante-info__title">Firmado por</h3>
          <div class="firmante-info__row">
            <span class="firmante-info__label">Nombre</span>
            <span class="firmante-info__value">{{ firmante.nombre }}</span>
          </div>
          <div class="firmante-info__row">
            <span class="firmante-info__label">RUT</span>
            <span class="firmante-info__value">{{ firmante.rut }}</span>
          </div>
          <div class="firmante-info__row">
            <span class="firmante-info__label">Observación</span>
            <span class="firmante-info__value">{{ firmante.comentario }}</span>
          </div>
        </div>
        <p class="firma-page__error" *ngIf="saveError">{{ saveError }}</p>
        <div class="workspace-actions" *ngIf="draft.devolucionSigned">
          <button
            type="button"
            class="btn-primary-firma btn-primary-firma--disabled"
            disabled>
            Firmado
          </button>
        </div>
      </div>

      <div
        class="firma-panel__body firma-panel__body--workspace"
        [class.firma-panel__body--client]="hideRightTabs"
        [class.firma-panel__body--exito]="firmaMode === 'exito'"
        *ngIf="!isPaperMode && rightTab === 'firma' && !despachoFinalizado">
        <ng-container *ngIf="!hideRightTabs" [ngTemplateOutlet]="siguientePasoBtn"></ng-container>
        <div class="firma-chooser" *ngIf="firmaMode === 'chooser'">
          <button
            type="button"
            class="firma-chooser__card"
            [disabled]="draft.isSignature"
            (click)="startDigital()">
            <img
              class="firma-chooser__icon"
              src="assets/images/icons/icono_firma_digital.svg"
              alt="" />
            <span class="firma-chooser__label">Firma digital</span>
          </button>
          <button
            *ngIf="showClientQr"
            type="button"
            class="firma-chooser__card"
            [disabled]="draft.isSignature"
            (click)="startQr()">
            <img
              class="firma-chooser__icon"
              src="assets/images/icons/icono_escanear_qr.svg"
              alt="" />
            <span class="firma-chooser__label">Escanear QR</span>
          </button>
          <button
            type="button"
            class="firma-chooser__card"
            [disabled]="saving || draft.isSignature"
            (click)="goToFinalizarSinFirma()">
            <img
              class="firma-chooser__icon"
              src="assets/images/icons/icono_guia_no_firmada.svg"
              alt="" />
            <span class="firma-chooser__label">Guía No Firmada</span>
          </button>
        </div>
        <p class="workspace-hint" *ngIf="firmaMode === 'chooser' && draft.isSignature">Esta guía ya fue firmada.</p>
        <p class="workspace-hint" *ngIf="firmaMode === 'chooser' && saveHint">{{ saveHint }}</p>

        <ng-container *ngIf="firmaMode === 'digital'">
          <div class="workspace-row workspace-row--inline workspace-row--field">
            <label class="workspace-label" for="firmaRut">RUT</label>
            <div class="datos-field">
              <div class="rut-group">
                <input
                  id="firmaRut"
                  class="workspace-input"
                  [class.is-invalid]="recepcionErrors.rut"
                  type="text"
                  maxlength="8"
                  placeholder="Ingresa tu RUT"
                  [disabled]="draft.isSignature || recepcionSigned"
                  [attr.aria-invalid]="!!recepcionErrors.rut"
                  [attr.aria-describedby]="recepcionErrors.rut || recepcionErrors.dv ? 'firmaRutError' : null"
                  [(ngModel)]="draft.firmaRut"
                  (ngModelChange)="onRecepcionFieldChange()" />
                <input
                  id="firmaDv"
                  class="workspace-input workspace-input--dv"
                  [class.is-invalid]="recepcionErrors.dv"
                  type="text"
                  maxlength="1"
                  aria-label="Dígito verificador"
                  [disabled]="draft.isSignature || recepcionSigned"
                  [attr.aria-invalid]="!!recepcionErrors.dv"
                  [attr.aria-describedby]="recepcionErrors.rut || recepcionErrors.dv ? 'firmaRutError' : null"
                  [ngModel]="draft.firmaDv"
                  (ngModelChange)="onFirmaDvChange($event)" />
              </div>
              <small
                id="firmaRutError"
                class="datos-field__error"
                *ngIf="recepcionErrors.rut || recepcionErrors.dv">
                {{ recepcionErrors.rut || recepcionErrors.dv }}
              </small>
            </div>
          </div>

          <div class="workspace-row workspace-row--inline workspace-row--field">
            <label class="workspace-label" for="firmaNombre">Nombre</label>
            <div class="datos-field">
              <input
                id="firmaNombre"
                class="workspace-input"
                [class.is-invalid]="recepcionErrors.name"
                type="text"
                placeholder="Ingresa tu nombre"
                [disabled]="draft.isSignature || recepcionSigned"
                [attr.aria-invalid]="!!recepcionErrors.name"
                [attr.aria-describedby]="recepcionErrors.name ? 'firmaNombreError' : null"
                [(ngModel)]="draft.firmaNombre"
                (ngModelChange)="onRecepcionFieldChange()" />
              <small id="firmaNombreError" class="datos-field__error" *ngIf="recepcionErrors.name">
                {{ recepcionErrors.name }}
              </small>
            </div>
          </div>

          <div class="workspace-row workspace-row--inline workspace-row--field">
            <label class="workspace-label" for="firmaCorreo">Correo</label>
            <div class="correo-wrap datos-field">
              <input
                id="firmaCorreo"
                class="workspace-input"
                [class.is-invalid]="recepcionErrors.email"
                type="email"
                placeholder="Ingresa tu correo"
                [disabled]="draft.isSignature || recepcionSigned"
                [attr.aria-invalid]="!!recepcionErrors.email"
                [attr.aria-describedby]="recepcionErrors.email ? 'firmaCorreoError' : null"
                [(ngModel)]="draft.firmaCorreo"
                (ngModelChange)="onRecepcionFieldChange()" />
              <small
                id="firmaCorreoError"
                class="datos-field__error"
                *ngIf="recepcionErrors.email; else firmaCorreoHint">
                {{ recepcionErrors.email }}
              </small>
              <ng-template #firmaCorreoHint>
                <small class="workspace-hint">
                  Utilizaremos este para enviar una copia de la guía firmada.
                </small>
              </ng-template>
            </div>
          </div>

          <div class="workspace-row">
            <label class="workspace-label" for="firmaComentarios">comentarios</label>
            <textarea
              id="firmaComentarios"
              class="workspace-textarea workspace-textarea--sm"
              rows="3"
              placeholder="Ingresa tu observación"
              [disabled]="draft.isSignature || recepcionSigned"
              [(ngModel)]="draft.firmaComentarios"></textarea>
          </div>

          <p class="workspace-hint" *ngIf="draft.isSignature">Esta guía ya fue firmada.</p>
          <p class="workspace-hint" *ngIf="saveHint">{{ saveHint }}</p>
          <p class="firma-page__error form-error-summary" role="alert" *ngIf="saveError">
            <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
            {{ saveError }}
          </p>
          <div class="workspace-actions">
            <button
              type="button"
              class="btn-primary-firma"
              [disabled]="isRecepcionFirmaDisabled()"
              [class.btn-primary-firma--disabled]="isRecepcionFirmaDisabled()"
              (click)="startRecepcionFirma()">
              {{ saving ? 'Enviando…' : (draft.isSignature || recepcionSigned ? 'Firmado' : 'Firmar') }}
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="firmaMode === 'qr'">
          <div class="qr-panel" *ngIf="showClientQr; else qrDisabled">
            <div class="qr-wrapper">
              <qrcode
                *ngIf="qrLink"
                [qrdata]="qrLink"
                class="qr-code"
                [class.qr-blur]="qrState !== 'ready'"></qrcode>

              <div *ngIf="qrState === 'syncing'" class="qr-overlay">
                <div class="spinner-border text-primary" role="status"></div>
                <p>Enviando datos...</p>
              </div>

              <div *ngIf="qrState === 'offline'" class="qr-overlay qr-overlay--offline">
                <i class="bi bi-wifi-off qr-offline-icon"></i>
                <p>Sin conexión</p>
              </div>
            </div>
            <p class="qr-caption">Escanea con tu teléfono para firmar</p>
            <p class="qr-poll-hint" *ngIf="showQrPollHint">
              {{ qrPollHintText }}
            </p>
            <div *ngIf="qrState === 'offline'" class="qr-offline-link">
              <span>¿Sin conexión? <a (click)="startDigital()">Continúa aquí</a></span>
            </div>
          </div>
          <ng-template #qrDisabled>
            <p class="firma-page__error">Firma por QR no disponible.</p>
          </ng-template>
        </ng-container>

        <div class="firma-exito-panel" *ngIf="firmaMode === 'exito'">
          <div class="firma-exito-panel__content">
            <img
              class="firma-exito-panel__icon"
              src="assets/images/icons/check_firma_exito.svg"
              width="117"
              height="117"
              alt="" />
            <h2 class="firma-exito-panel__title">¡Firma registrada con éxito!</h2>
            <p class="firma-exito-panel__text">
              Guía Nº {{ folioLabel }}
              <ng-container *ngIf="draft.firmaCorreo">
                <br />
                Recibirás un mail con la copia de la guía firmada.
              </ng-container>
            </p>
            <p class="workspace-hint firma-exito-panel__hint" *ngIf="saveHint">{{ saveHint }}</p>
          </div>
          <button type="button" class="btn-outline-firma firma-exito-panel__btn" (click)="finalizarEntrega()">
            Finalizar entrega
          </button>
        </div>
      </div>

      <div class="firma-panel__body firma-panel__body--workspace" *ngIf="rightTab === 'finalizar' && !hideRightTabs">
        <div class="finalizar-aviso" *ngIf="guiaNoFirmada">
          <i class="bi bi-info-circle" aria-hidden="true"></i>
          <div>
            <p class="finalizar-aviso__title">Se finalizará con guía no firmada</p>
           
          </div>
        </div>
        <p class="finalizar-copy" *ngIf="!guiaNoFirmada">
          Antes de finalizar este despacho, ¿desea dejar un comentario?
        </p>
        <p class="finalizar-copy" *ngIf="guiaNoFirmada">
          Cuando hayas completado observación, agua y/o devolución, puedes finalizar el despacho sin firma del cliente.
        </p>
        <div class="workspace-row">
          <label class="workspace-label" for="firmaComentariosFinal">comentarios</label>
          <textarea
            id="firmaComentariosFinal"
            class="workspace-textarea"
            rows="5"
            placeholder="Ingresa tu comentario"
            [(ngModel)]="comentariosFinal"></textarea>
        </div>
        <p class="workspace-hint" *ngIf="saveHint">{{ saveHint }}</p>
        <p class="firma-page__error" *ngIf="saveError">{{ saveError }}</p>
        <div class="workspace-actions">
          <button type="button" class="btn-primary-firma" [disabled]="saving" (click)="finalizeMock()">
            Finalizar
          </button>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #siguientePasoBtn>
  <div class="siguiente-paso-bar">
    <button type="button" class="siguiente-paso" (click)="goToNextRightTab()">
      Siguiente paso
      <i class="bi bi-arrow-right" aria-hidden="true"></i>
    </button>
  </div>
</ng-template>

<ng-template #loadingOrError>
  <div class="firma-page firma-page--state">
    <p *ngIf="loading">Cargando despacho…</p>
    <p *ngIf="!loading && loadError" class="firma-page__error">{{ loadError }}</p>
    <button *ngIf="!loading" type="button" class="firma-page__back" (click)="goBack()">Atrás</button>
  </div>
</ng-template>

<ng-template #modalFirmaExito>
  <div class="firma-modal firma-modal--center firma-exito-modal firma-exito-modal--listo">
    <button
      type="button"
      class="firma-exito-modal__close"
      (click)="acceptFirmaSuccess()"
      aria-label="Cerrar">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
    <div class="firma-exito-modal__icon" aria-hidden="true">
      <img src="assets/images/icons/check_blue.svg" alt="" />
    </div>
    <h6 class="firma-exito-modal__title">¡Listo!</h6>
    <p class="firma-exito-modal__text" *ngIf="firmaExitoTexto">{{ firmaExitoTexto }}</p>
  </div>
</ng-template>

<ng-template #modalQrClienteFirma>
  <div
    *ngIf="qrClientStatus.signed; else qrClientWaitModal"
    class="firma-modal firma-modal--center firma-exito-modal firma-exito-modal--listo">
    <button
      type="button"
      class="firma-exito-modal__close"
      (click)="closeQrClientFirmaModal()"
      aria-label="Cerrar">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
    <div class="firma-exito-modal__icon" aria-hidden="true">
      <img src="assets/images/icons/check_blue.svg" alt="" />
    </div>
    <h6 class="firma-exito-modal__title">¡Listo!</h6>
    <p class="firma-exito-modal__text">El cliente firmó la guía</p>
  </div>
  <ng-template #qrClientWaitModal>
    <div
      class="firma-modal firma-modal--center qr-client-modal"
      [class.qr-client-modal--expired]="qrWaitExpired">
      <button
        type="button"
        class="firma-exito-modal__close"
        (click)="closeQrClientFirmaModal()"
        aria-label="Cerrar">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
      <p class="qr-client-modal__text">{{ qrClientModalText }}</p>

      <div class="qr-client-modal__status">
        <ng-container *ngIf="!qrWaitExpired">
          <p class="qr-client-modal__clock">{{ qrCountdownLabel }}</p>
          <p class="qr-client-modal__wait">Tiempo de espera (15 min)</p>
        </ng-container>
        <ng-container *ngIf="qrWaitExpired">
          <p class="qr-client-expired__label">Tiempo de espera expirado</p>
          <p class="qr-client-modal__clock">{{ qrCountdownLabel }}</p>
        </ng-container>
        <p class="qr-client-modal__offline" *ngIf="qrPollOffline">
          Sin conexión. Último estado conocido.
        </p>
      </div>

      <button
        *ngIf="qrWaitExpired"
        type="button"
        class="btn-outline-firma qr-client-expired__back"
        (click)="regresarDesdeEsperaExpirada()">
        Regresar
      </button>
    </div>
  </ng-template>
</ng-template>

<ng-template #modalFinalizarDespacho>
  <div class="firma-modal firma-modal--center firma-finalizar-modal">
    <h6 class="firma-finalizar-modal__title">Vas a finalizar el despacho</h6>
    <p class="firma-finalizar-modal__text">
      Una vez que finalices, la información quedará bloqueada y no podrás hacer cambios.
    </p>
    <p class="firma-finalizar-modal__text" *ngIf="guiaNoFirmada">
      Este despacho se cerrará con guía no firmada.
    </p>
    <div class="workspace-actions workspace-actions--center firma-finalizar-modal__actions">
      <button type="button" class="btn-outline-firma firma-finalizar-modal__btn" (click)="closeDialog()">
        Volver a editar
      </button>
      <button
        type="button"
        class="btn-primary-firma firma-finalizar-modal__btn"
        [disabled]="saving"
        [class.btn-primary-firma--disabled]="saving"
        (click)="confirmFinalizeDespacho()">
        {{ saving ? 'Enviando…' : 'Finalizar Despacho' }}
      </button>
    </div>
  </div>
</ng-template>

<app-hormigon-encuesta-satisfaccion
  [(isSurveyVisible)]="surveyVisible"
  [receiverName]="draft.firmaNombre"
  (surveySubmittedSuccessEvent)="onSurveySubmitted()">
</app-hormigon-encuesta-satisfaccion>
